import { Icon } from '@timeedit/ui-components';
import {
  Dropdown,
  type DropdownProps,
  Typography,
} from '@timeedit/ui-components/antd';

export type DropdownMenuProps = DropdownProps & { 'data-testid'?: string };

const DropdownMenu = ({
  'data-testid': dataTestid,
  ...rest
}: DropdownMenuProps) => {
  return (
    <div className="te-mt-2" data-testid={dataTestid}>
      <Dropdown trigger={['click']} {...rest}>
        <Typography.Link data-testid="add-btn">
          Add
          <Icon
            id="DownOutlined"
            alt="Down"
            style={{ width: 10, marginLeft: 10 }}
          />
        </Typography.Link>
      </Dropdown>
    </div>
  );
};

export default DropdownMenu;
